import { Component, inject } from "@angular/core";
import { IdleService } from "../idle.service";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { IdleStateTypes } from "../idle-state-types.enum";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    templateUrl: "./idle-dialog.component.html",
    styleUrls: ["./idle-dialog.component.scss"],
    standalone: false
})
export class IdleDialogComponent {
  idleService = inject(IdleService);
  data = inject(MAT_DIALOG_DATA);
  private mdDialogRef = inject<MatDialogRef<IdleDialogComponent>>(MatDialogRef);

  dialogRef: DynamicDialogRef;
  IdleStateTypes = IdleStateTypes;
  

  public IsWarningMode(): boolean {
    return this.idleService.idleState === IdleStateTypes.warning;
  }

  public countdown(): number {
    return this.idleService.countdown;
  }

  public continue(): void {
    this.mdDialogRef.close(false);
    location.reload();
  }

  public logout(): void {
    this.mdDialogRef.close(true);
  }

  public getTitle(): string {
    return this.IsWarningMode()
      ? "You Appear To Be Inactive."
      : "Your Session Has Expired.";
  }
}
